import { makeStyles } from '@material-ui/core/styles';
import { BaseWallboardWidgetPositionProps, BaseWallboardWidgetSizeProps, BaseWallboardWidgetViewProps } from '../../store/types/Wallboard';
import { Colors } from '../../styles/Colors';

export const defaultColumnsAmount = 8;

export const useStyles = makeStyles(() => ({
    container: {
        height: '100vh',
        overflowX: 'hidden',
        overflowY: 'auto',
        flex: 1,
        background: Colors.White
    },
    containerDarkMode: {
        background: '#14131B'
    },
    scrollableContainer: {
        display: 'flex',
        minHeight: '100vh',
        flex: 1,
        backgroundColor: Colors.White
    },
    scrollableContainerDarkMode: {
        background: '#14131B'
    },
    containerPadding: {
        background: Colors.White,
        padding: '0px 0px 0px 0px',
        display: 'flex',
        flexDirection: 'column',
        width: 'calc(100% - 32px)',
        position: 'relative'
    },
    containerPaddingDarkMode: {
        background: '#14131B'
    },
    headerContainer: {
        paddingLeft: 96,
        paddingTop: 48,
        paddingBottom: 16,
        width: 'calc(100% - 96px)',
        height: 66,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    headerContainerLeftPart: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'left'
    },
    headerContainerFullScreen: {
        height: 65,
        paddingLeft: 22.7,
        paddingRight: 18,
        width: 'calc(100% - 40.7px)',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    darkModeHeader: {
        fontWeight: 700,
        fontSize: 16,
        color: Colors.Text
    },
    darkModeHeaderInDarkMode: {
        color: '#A1A1A4',
    },
    closeButtonContainer: {
        color: Colors.Secondary1,
        display: 'flex',
        flexDirection: 'row',
        height: 'fit-content',
        cursor: 'pointer'
    },
    closeButtonContainerDarkMode: {
        color: '#A1A1A4',
    },
    mainHeader: {
        fontSize: 32,
        color: Colors.Gray7,
        fontWeight: 500,
    },
    doughnutsContainer: {
        width: '100%',
        position: 'absolute',
        top: 98,
        minHeight: 'calc(100vh - 98px)',

        '& .react-grid-item.react-grid-placeholder': {
            backgroundColor: Colors.Secondary5,
            border: '1px dashed ' + Colors.Secondary2,
            borderRadius: 4,
            zIndex: 3,
        }
    },
    reactGridLayout: {
        background: Colors.White
    },
    reactGridLayoutDarkMode: {
        background: '#14131B'
    },
    doughnutsContainerInFullScreenMode: {
        top: 65,
        minHeight: 'calc(100vh - 65px)',
    },
    doughnutsContainerDarkMode: {
        background: '#14131B'
    },
    react_grid_layout: {
        position: 'relative',
        transition: 'height 200ms ease',
    },
    reactGridItem: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 200ms ease',
        transitionProperty: 'left, top',
        background: Colors.White,
        fontFamily: 'Arial, Helvetica, sans-serif',
        textAlign: 'center',
        border: '1px solid ' + Colors.Border,
        borderRadius: 16,
        zIndex: 5,
        
        '& .MuiButtonBase-root': {
            visibility: 'hidden'
        },
    },
    reactGridItemDarkMode: {
        background: '#201F2B',
        borderColor: '#201F2B',
    },
    resizeHandle: {
        display: 'flex',
        position: 'absolute',
        width: 22,
        height: 22,
        right: 0,
        bottom: 0,
        background: 'transparent',
        color: 'transparent',
        cursor: 'pointer',
        zIndex: 9,
        visibility: 'hidden',
        
        '& svg': {
            width: 12,
            height: 12,

            '& path': {
                fill: `${Colors.Gray5} !important`,
                fillOpacity: 1,
            },
        },
    },
    resizeHandleDarkMode: { 
        background: 'linear-gradient(135deg, rgba(35,35,46,1) 0%, rgba(254,254,254,1) 40%)',
        width: 32,
        height: 32,
        borderRadius: 1,

        '& svg': {
            marginTop: 10,
            marginLeft: 10,

            width: 12,
            height: 12,

            '& path': {
                fill: `#434244 !important`,
                fillOpacity: 1,
            },
        },
    },
    deleteButton: {
        position: 'absolute',
        top: 8,
        right: 5.5,
        width: 40,
        height: 40,
        fontSize: 18,
        zIndex: 8,
        background: Colors.White,
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.15)',

        '&:hover': {
            background: `${Colors.White} !important`,
        },
        
        '& .MuiIconButton-root': {
            '&:hover': {
                background: `${Colors.White} !important`,
            },
        },
        
        '&:disabled': {
            background: `${Colors.White} !important`,
        },
    },
    editButton: {
        position: 'absolute',
        top: 8,
        right: 49.5,
        width: 40,
        height: 40,
        fontSize: 18,
        zIndex: 8,
        background: Colors.White,
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.15)',
        
        '&:hover': {
            background: `${Colors.White} !important`,
        },
        
        '& .MuiIconButton-root': {
            '&:hover': {
                background: `${Colors.White} !important`,
            },
        },
        
        '&:disabled': {
            background: `${Colors.White} !important`,
        },
    },
    actionButtonDarkMode: {
        background: '#201F2B',
        boxShadow: '0px 4px 4px #1B1B25',
        color: '#D4D8DE',
        
        '&:hover': {
            background: `#201F2B !important`,
        },
        
        '& .MuiIconButton-root': {
            '&:hover': {
                background: `#201F2B !important`,
            },
        },
        
        '& svg': {
            '& path': {
                fill: `#D4D8DE !important`,
                fillOpacity: 1,
            },
        },
    },
    widgetTypeIcon: {
        position: 'absolute',
        top: 20,
        left: 18,
    },
    widgetTypeIconDarkMode: {
        '& svg': {
            '& path': {
                fill: '#E4EBF3',
            },
        },
    },
    widgetTitle: {
        position: 'absolute',
        top: 18,
        left: 44,
        color: Colors.Secondary,
        maxWidth: 'calc(100% - 44px - 10px)',
        width: 'fit-content',
        fontWeight: 700,
        fontSize: 18,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    },
    widgetTitleDarkMode: {
        color: '#E4EBF3'
    },
    widgetFrame: {
        width: 'calc(100% - 32px)',
        height: 'calc(100% - 56px - 9px)',
        zIndex: 7,
        padding: '8px 16px 0px 16px',
        position: 'absolute',
        top: 56,
        left: 0
    },
    widgetFrameDarkMode: {
        borderTop: '1px solid #DDE0E5'
    },
    fullWidthContainer: {
        width: '100%',
        paddingLeft: 0,
        paddingRight: 0
    },
    emptyRightMarginContainer: {
        width: 'calc(100% - 16px)',
        paddingRight: 0
    },
    addWidgetButton: {
        marginTop: -4,
        marginLeft: 36,
        color: Colors.White
    },
    plusIcon: {
        '& svg.MuiSvgIcon-root path': {
            fill: Colors.White + '!important',
            fillOpacity: 1,
        },
    },
    refreshButton: {
        width: 40,
        height: 40,
        marginLeft: 16,
        marginTop: -4
    },
    refreshTimeContainer: {
        display: 'flex',
        alignItems: 'flex-end',
        color: Colors.Text,
        flexDirection: 'column',
        width: 'fit-content',
        lineHeight: 1.2,
        marginTop: 3,
        marginLeft: 12
    },
    timeText: {
        fontStyle: 'italic',
        marginLeft: 10,
    },
    noWrap: {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        fontStyle:'italic',
        color:Colors.Text3
    },
    selectedWidget: {
        border: '1px solid ' + Colors.Secondary12,
        boxShadow: '0px 2px 12px rgba(0, 0, 0, 0.15)',

        '& .MuiButtonBase-root': {
            visibility: 'visible'
        },

        '& .widget-frame-dark-mode': {
            borderTop: '1px solid #DDE0E5'
        }
    },
    selectedResizer: {
        visibility: 'visible'
    },
    moveButton: {
        position: 'absolute',
        top: 10,
        left: '50%',
        width: 16,
        height: 4,
        fontSize: 18,
        zIndex: 10,
        background: 'transparent',
        cursor: 'pointer'
    },
    deleteAlert: {
        '& .MuiDialogContent-root': {
            width: 233,
            minWidth: 'unset',
            padding: 24,
            paddingBottom: 27,
            background: Colors.White,
        },
    },
    fullscreenButtonContainer: {

    },
    fullscreenButton: {
        width: 40,
        height: 40,
        marginLeft: 16,
        marginTop: -8
    }
}));

export const calculateFreeSpace = (need: BaseWallboardWidgetSizeProps, exists: BaseWallboardWidgetViewProps[]) => {

    const isCellBusy = (px: number, py: number) => {
        for(const el of exists) {
            const busyX = px >= el.x && px < (el.x + el.w);
            const busyY = py >= el.y && py < (el.y + el.h);
            if(busyX && busyY) 
                return true;
        }
        return false;
    }

    for (let y=0; y < 1000; y++) {
        for (let x=0; x <= defaultColumnsAmount - need.w; x++) {
            
            let isPossible = true;
            for (let dx=0; dx < need.w; dx++) {
                for (let dy=0; dy < need.h; dy++) {
                    const isBusy = isCellBusy(x + dx, y + dy);
                    if(isBusy) {
                        isPossible = false;
                        break;
                    }
                }

                if(!isPossible) {
                    break;
                }
            }

            if(isPossible) {
                return {
                    x: x,
                    y: y
                } as BaseWallboardWidgetPositionProps;
            }
        }
    }
}